import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const MediaDownloadButton = ({ url, filename, isDarkMode, className = '' }) => {
  const handleDownload = () => {
    // Open in new tab/window for download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'download';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  const themeClass = isDarkMode ? 'dark' : 'light';
  
  return (
    <Button
      icon={<DownloadOutlined />}
      onClick={handleDownload}
      className={`media-download-button ${themeClass} ${className}`}
      title={`Download ${filename || 'file'}`}
      type="text"
      aria-label={`Download ${filename || 'file'}`}
    />
  );
};

export default MediaDownloadButton;
